<template>
  <md-field v-bind="{ mdClearable: $attrs.mdClearable }" class="no-will-change">
    <v-select v-if="Array.isArray(types)"
      label="name"
      :options="types"
      :reduce="type => type.country_iso3"
      :append-to-body="true"
      v-model="value"
      @input="inputEvent"
    >
      <template #list-footer>
        <li v-show="hasNextPage" ref="load" class="loader">
          Loading more options...
        </li>
      </template>
    </v-select>
  </md-field>
</template>

<script>
import Api from "@/openapi/src/api/CountryApi.js";
import SelectMixins from "./SelectMixins";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';


export default {
  name: "CountrySelect",
  components: { vSelect },
  mixins: [SelectMixins],
  props: {
    value: {
      type: String
    }
  },
  created() {
    if (!this.$store.getters.get(this.$options.name)) {
      var api = new Api();
      this.$store.dispatch("fetch", {
        name: this.$options.name,
        function: api.getCountries.bind(api)
      });
    }
  },
  methods: {
    inputEvent(val) {
      this.$emit('input', val);
    }
  }
};
</script>
<style lang="scss">
.v-select {
  width: 13rem;
  .vs__dropdown-toggle {
    border: 0px;
  }
}
</style>